import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import StringHelpers from '../../../../../../helpers/string-helpers';

const AptitudeTestFormTimer = props => {
  const { startOn = 10, onExpire } = props;

  const [time, setTime] = useState();

  useEffect(() => {
    setTime(Math.floor((startOn - new Date()) / 1000));
  }, [startOn]);

  useEffect(() => {
    let interval = null;
    const timInit = typeof time === 'number';

    if (timInit && time) {
      interval = setInterval(() => {
        setTime(Math.floor((startOn - new Date()) / 1000));
      }, 1000);
    }

    if (timInit && time <= 0) {
      typeof onExpire === 'function' && onExpire();
      setTime(0);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [time]);

  const m = StringHelpers.appendLeadingZeroes(Math.floor(time / 60));
  const s = StringHelpers.appendLeadingZeroes(time - m * 60);

  return <div className="aptitude-test-timer">{`${m}:${s}`}</div>;
};

AptitudeTestFormTimer.propTypes = {
  startOn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onExpire: PropTypes.func,
};

export default AptitudeTestFormTimer;
